import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { showToast } from '../utils/helpers';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getRedactions, deleteRedaction } from "../lib/apiClient";
import RedactionConfiguration from "../Components/Redactions/Configuration";
import store from "../stores";

const Redactions = observer((props) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [redaction, setRedaction] = useState(null);
  const [redactions, setRedactions] = useState([]);
  const [showConfiguration, setShowConfiguration] = useState(false);
  const [isSubmitting, ] = useState(false);

  useEffect(() => {
    listRedactions();
  // eslint-disable-next-line
  }, []);

  const handleDelete = async()  => {
        
    const params = {
      accountSid: props.store.SessionStore.accountSid,
      redactionSid: redaction.sid        
    }
    
    const response = await deleteRedaction(params);

    if(response.successful){
      
      // loop all redactions and pull out the one that is in the store...
      if(redactions.length){
        setRedactions(redactions.filter(item => item.sid !== redaction.sid) );
      }
      // close the modal..
      setShowDeleteConfirmation(false);
      setRedaction(null);
      showToast("The redaction has been deleted!");
    }
   
  };

  const listRedactions = async ()=>{
    const redactionsResponse = await getRedactions({accountSid: props.store.SessionStore.getAccountSid()});
    if(redactionsResponse?.data?.records){
      setRedactions(redactionsResponse.data.records);
    }
  }

  const handleEdit = (redaction)=>{
    setRedaction(redaction);
    setShowConfiguration(true);
  }

  const handleConfirmDeleteClose = ()=>{
    setShowDeleteConfirmation(false); 
    setRedaction(null);
  }

  const confirmDelete = (redaction)=>{
    setRedaction(redaction);
    setShowDeleteConfirmation(true);
  }

  const displayBucket = (redaction) => {
    if(redaction.buckets.length && redaction.buckets.length === 1 && redaction.buckets[0] === '*'){
      return 'All';
    }else{
      const buckets = store.SessionStore.buckets.filter(item => redaction.buckets.includes(item.sid));
      if(buckets){
        return buckets.length;
      }else{
        return 'Unknown';
      }
    }
  }
  const displayEnvironments = (redaction) => {
    if(redaction.environments.length && redaction.environments.length === 1 && redaction.environments[0] === '*'){
      return 'All';
    }else{
      const environments = store.SessionStore.environments.filter(item => redaction.environments.includes(item.sid));
      if(environments){
        return environments.length;
      }else{
        return 'Unknown';
      }
    }
  }
  const displayScopes = (redaction) => {
    if(redaction.scopes.length && redaction.scopes.length === 1 && redaction.scopes[0] === '*'){
      return 'All';
    }else{
      if(redaction.scopes){
        return redaction.scopes.length;
      }else{
        return 'Unknown';
      }
    }
  }

  return (
    <>
      {!showConfiguration ? (<>

      {redactions.length ? (
        <>
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">&nbsp;</h2>
            <Button variant="success"  onClick={()=>{
            setShowConfiguration(true);
            }} >Add Redaction</Button> 
        </div>
        <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">                    
                                <div className="table">
                                    <table className="table">
                                    <thead>
                                        <tr>
                                        <th>&nbsp;</th>
                                        <th>Type</th>
                                        <th className="text-center">Bucket</th>
                                        <th className="text-center">Environments</th>
                                        <th className="text-center">Scopes</th>
                                        <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-border-bottom-0">
                                    {redactions.map((redaction) => (                      
                                        <tr key={`detail_${redaction.sid}`}>
                                        <td>{redaction.redactAt === 'client' ? (<i className="ti ti-code me-2 ti-sm"></i>) : (<i className="ti ti-server me-2 ti-sm"></i>)}</td>  
                                        <td>{redaction.type} {redaction.pattern}</td>
                                        
                                        <td className="text-center">{displayBucket(redaction)}</td>
                                        <td className="text-center">{displayEnvironments(redaction)}</td>
                                        <td className="text-center">{displayScopes(redaction)}</td>
                                        <td className="text-center">
                                            <div className="dropdown text-center">
                                            <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown"><i className="ti ti-dots-vertical"></i></button>
                                            <div className="dropdown-menu">
                                                <button className="dropdown-item btn-link" onClick={()=>handleEdit(redaction)} ><i className="ti ti-pencil me-1 mb-1"></i>Edit</button>
                                                <button className="dropdown-item btn-link" onClick={()=>confirmDelete(redaction)} ><i className="ti ti-trash me-1 mb-1"></i>Delete</button>
                                            </div>
                                            </div>
                                        </td>
                                        </tr>    
                                        ))}          
                                    </tbody> 
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        ) : (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="text-center flex-column">
                                    <h3>No Redactions Setup</h3>
                                    <p>If you have some sensitive data that does not need to leave your servers or should not be persisted, you can create a redaction to ensure data is handled properly.</p>
                                    <Button variant="success"  onClick={()=>{
                                    setShowConfiguration(true);          
                                    }} >Add Redaction</Button> 
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}

    </>) : (<>
      <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">   
        <RedactionConfiguration {...props}
                close={()=>{
                  setShowConfiguration(false);
                  setRedaction(null);
                }}
                redaction={redaction}
                onComplete={(newRedaction)=>{
                  
                  listRedactions();
                  
                  if(redaction){
                    showToast("Redaction updated and any online servers have been pushed the update!");
                  }else{
                    showToast("Redaction created and any online servers have been pushed the update!");
                  }       
                  setRedaction(null);
                }}/>
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </>)}

        <Modal show={showDeleteConfirmation} onHide={handleConfirmDeleteClose} >
          <Modal.Header closeButton>
            <Modal.Title>Delete Redaction</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this redaction?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleConfirmDeleteClose}>Cancel</Button>
            {!isSubmitting ? (
                <Button variant="danger"  onClick={handleDelete}>Delete Redaction</Button>
            ) : (
                <Button variant="danger" > <span className="spinner-border me-1" role="status" aria-hidden="true"></span>Deleting...</Button>
            )}  
          </Modal.Footer>
          
      </Modal>



    </>
  );
});

export default Redactions;
